import api from './api';

export interface MissingAnimal {
  id: number;
  animal_id: number;
  last_seen_location: string;
  contact_email?: string;
  contact_phone?: string;
  image_url?: string;
  description?: string;
  found_at?: string;
  is_found: boolean;
  created_at: string;
  updated_at: string;
  animal?: {
    id: number;
    name: string;
    species: string;
    breed?: string;
    gender?: string;
    color?: string;
    description?: string;
    owner_id?: number;
  };
}

export interface CreateMissingAnimalData {
  animal_id: number;
  last_seen_location: string;
  contact_email?: string;
  contact_phone?: string;
  image_url?: string;
  description?: string;
}

class MissingAnimalService {
  async getMissingAnimals(includeFound: boolean = false): Promise<MissingAnimal[]> {
    const response = await api.get('/missing-animals', {
      params: { include_found: includeFound }
    });
    return response.data;
  }

  async getMyMissingAnimals(includeFound: boolean = false): Promise<MissingAnimal[]> {
    const response = await api.get('/missing-animals/my', {
      params: { include_found: includeFound }
    });
    return response.data;
  }

  async getMissingAnimal(id: number): Promise<MissingAnimal> {
    const response = await api.get(`/missing-animals/${id}`);
    return response.data;
  }

  async createMissingAnimal(data: CreateMissingAnimalData): Promise<MissingAnimal> {
    const response = await api.post('/missing-animals', data);
    return response.data;
  }

  async updateMissingAnimal(id: number, data: Partial<CreateMissingAnimalData>): Promise<MissingAnimal> {
    const response = await api.put(`/missing-animals/${id}`, data);
    return response.data;
  }

  async markAsFound(id: number): Promise<MissingAnimal> {
    const response = await api.post(`/missing-animals/${id}/found`);
    return response.data;
  }
}

export const missingAnimalService = new MissingAnimalService();
